import { FirebaseOptions } from "firebase/app";

export const getFirebaseOptions = (): FirebaseOptions => getConfig().firebase.firebaseOptions;

export const getFirebaseVapidKey = () => getConfig().firebase.vapidKey;

export const getSentryDsn = () => {
	if (import.meta.env.VITE_APP_CI_COMMIT_BRANCH !== "master") return null;

	return getConfig().sentry.dsn;
};

export const getFrontendReleaseCode = () => import.meta.env.VITE_APP_RELEASE_CODE;

export const getMapboxAccessToken = () => getConfig().mapbox.accessToken;

const getConfig = (): any => {
	if (import.meta.env.DEV) return getDevConfig();

	return getProdConfig();
};

const getDevConfig = () => ({
	firebase: {
		firebaseOptions: {
			apiKey: "AIzaSyC_oxjm4Wq9fBTEkQBBGpGOhWIWmLrRNVA",
			authDomain: "aavo-dev.firebaseapp.com",
			projectId: "aavo-dev",
			storageBucket: "aavo-dev.appspot.com",
			messagingSenderId: "717179742357",
			appId: "1:717179742357:web:e8c063470a169386fd939c",
		},
		vapidKey:
			"BNl6XpoBPa1lgWw4p3szpXGltWTEQft1AjLY1fw1F5AT-XUVCWrXARUUD7sDswn-znqW28gX1Vn7DhPZZFpFBcA",
	},
	sentry: {
		dsn: null,
	},
	mapbox: {
		accessToken:
			"pk.eyJ1IjoicGF1bHVzbGltbWEiLCJhIjoiY2xya2dycWdjMGQxMjJpazQyYTZjbGZpcyJ9.A_aJDmruza7cE2_B5u6tIQ",
	},
});

const getProdConfig = () => {
	const configJson = import.meta.env.VITE_APP_CONFIG;
	if (!configJson) throw Error("Production configuration is not defined");

	return JSON.parse(configJson);
};
